
import { useState } from 'react';
import BookingModal from './BookingModal';

export default function HeroSection() {
  const [isBookingOpen, setIsBookingOpen] = useState(false);

  return (
    <>
      <section 
        className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(139, 115, 85, 0.3), rgba(107, 91, 71, 0.4)), url('https://static.readdy.ai/image/5f12d79e9d850055a25ce719729b8deb/6ba44bed24e6143b0a15f1a0c75d1c9d.jpeg')`
        }}
      >
        <div className="container mx-auto px-6 text-center text-white relative z-10">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
              Masszázs17 – Budapest XVII. kerület
            </h1>
            <p className="text-xl md:text-2xl mb-8 leading-relaxed font-light">
              Relaxáció és fájdalomcsökkentés egy helyen. Barátságos és közvetlen masszázs, a mindennapi feszültség oldásához.
            </p>
            <a
              href="https://app.minup.io/book/zoltan-grendorf/category/67f7bc13-1ad6-40f0-addc-782133eed473"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-amber-600 hover:bg-amber-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-line mr-2"></i>
              Időpontot kérek
            </a>
          </div>
        </div>
        
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce">
          <i className="ri-arrow-down-line text-2xl"></i>
        </div>
      </section>

      <BookingModal isOpen={isBookingOpen} onClose={() => setIsBookingOpen(false)} />
    </>
  );
}
